import React from 'react'
import { t } from 'ttag'

import styles from './QuestionPreview.module.scss'
import { Box } from 'components/layout/Box/Box'
import { List } from 'components/shared/List/List'

type QuestionPreviewProps = {
  id?: string | number
  count?: number
  total?: number
  title?: string
  description?: string
}

export const QuestionPreview = ({
  id,
  count,
  total,
  title,
  description,
}: QuestionPreviewProps) => (
  <List.Item className={styles.item} key={id}>
    {count && <span className={styles.count}>{t`${count} of ${total}`}</span>}
    <h3 className={styles.title}>{title}</h3>
    {(description?.length ?? 0) > 0 ? (
      <Box className={styles.container} direction="column">
        <p className={styles.description}>{description}</p>
      </Box>
    ) : null}
  </List.Item>
)
